import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { BannerManutenzioneComponent } from '../banner-manutenzione/banner-manutenzione.component';

@Component({
  selector: 'app-notifications',
  standalone: false,

  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss',
})
export class NotificationsComponent {
  public menuMan: boolean = false;
  public mostraMenu: boolean = false;

  isManutenzione(isManutenzione: boolean) {
    this.menuMan = isManutenzione;
    this.mostraMenu = this.menuMan;
  }
}
